import React, { Component } from 'react';
import Radium from 'radium';
import Spinner from 'react-spinkit';
import PropTypes from 'prop-types';
import StylePropType from 'react-style-proptype';

const IMAGE_STATUS = {
  loading: 'loading',
  loaded: 'loaded',
  failed: 'failed',
};

class ProjectImageElement extends Component {
  constructor(props) {
    super(props);
    this.state = { imageStatus: IMAGE_STATUS.loading };
    this.handleImageLoaded = this.handleImageLoaded.bind(this);
    this.handleImageErrored = this.handleImageErrored.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.imageUrl !== this.props.imageUrl) {
      this.setState({ imageStatus: IMAGE_STATUS.loading });
    }
  }

  handleImageLoaded() {
    this.setState({ imageStatus: IMAGE_STATUS.loaded });
  }

  handleImageErrored() {
    this.setState({ imageStatus: IMAGE_STATUS.failed });
  }

  renderImage() {
    let style = { maxHeight: '100%' };
    if (this.state.imageStatus !== IMAGE_STATUS.loaded) {
      style = { display: 'none' };
    }

    const spinnerStyle = {
      ...this.props.spinnerStyle,
      position: 'absolute',
      top: '50%',
      left: '50%',
    };
    return (
      <div
        style={{
          position: 'relative',
          flex: 1,
          overflow: 'hidden',
          height: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <img
          alt={''}
          src={this.props.imageUrl}
          width={this.props.width}
          height={this.props.height}
          onLoad={this.handleImageLoaded}
          onError={this.handleImageErrored}
          style={[this.props.imageStyle, style]}
        />
        {this.state.imageStatus === IMAGE_STATUS.failed && this.state.imageStatus}
        {this.state.imageStatus === IMAGE_STATUS.loading && (
          <Spinner name="ball-triangle-path" fadeIn="none" style={spinnerStyle} />
        )}
      </div>
    );
  }

  render() {
    const { imageUrl, containerStyle } = this.props;
    const placeholderStyles = !imageUrl
      ? {
        background: '#ccc',
      }
      : null;

    const iconStyle = { color: '#aaa', fontSize: '50px' };

    return (
      <div
        style={[
          {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flex: 1,
            position: 'relative',
            height: '75px',
            width: '75px',
          },
          containerStyle,
          placeholderStyles,
        ]}
      >
        {this.props.imageUrl && this.renderImage()}
        {!this.props.imageUrl && <i className="fa fa-image" style={iconStyle} />}
      </div>
    );
  }
}

ProjectImageElement.defaultProps = {
  style: {},
  spinnerStyle: {},
  imageUrl: '',
};

ProjectImageElement.propTypes = {
  imageUrl: PropTypes.string,
  width: PropTypes.string.isRequired,
  height: PropTypes.string.isRequired,
  style: StylePropType,
  spinnerStyle: StylePropType,
};

export default Radium(ProjectImageElement);



// WEBPACK FOOTER //
// ./src/components/Project/ProjectImageElement/ProjectImageElement.js